module.exports = __webpack_public_path__ + "img/symbol_5.1517087f.png";